/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, useContext, useState, useCallback } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import UrlService from '../../services/UrlService';

const ContextAPI = createContext({});

export function useDuplicateUid() {
    return useContext(ContextAPI);
}

export function DuplicateUidProvider({ children }) {
    const axiosPrivate = useAxiosPrivate();
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalGroups, setTotalGroups] = useState(0);

    const fetchGroups = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axiosPrivate.get(UrlService.getDuplicateUidListUrl());
            if (res?.data?.status === 'success') {
                setGroups(res.data.groups || []);
                setTotalGroups(res.data.total_groups || 0);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [axiosPrivate]);

    return (
        <ContextAPI.Provider value={{ groups, setGroups, loading, totalGroups, fetchGroups }}>
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
